import { render, staticRenderFns } from "./IssueDetailsPopup.vue?vue&type=template&id=0ba8733f&scoped=true"
import script from "./IssueDetailsPopup.vue?vue&type=script&lang=js"
export * from "./IssueDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./IssueDetailsPopup.vue?vue&type=style&index=0&id=0ba8733f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8733f",
  null
  
)

export default component.exports